export default "__VITE_ASSET__DhFw_846__"